<template>
    <ds-modal
        class="sms-broadcast-feedback-modal"
        data-qa="sms-broadcast-feedback-modal"
        is-open
        show-close
        size="med"
        @close="handleClose"
    >
        <template #title>
            <strong class="feedback-modal-title">{{ headerText }}</strong>
        </template>

        <template #default>
            <form class="feedback-modal-form" novalidate @submit.prevent="submit">
                <p class="description1">
                    {{ textMsg }}
                </p>

                <p class="description2">
                    {{ infoText }}
                </p>

                <ds-text-area-field
                    v-model="feedback"
                    :invalid="showError && !feedback"
                    :label="warnMsgOne"
                    :submitted="showError && !feedback"
                    required
                >
                    <template v-if="showError && !feedback" #help>
                        <span class="feedback-help-text">{{ warnMsgTwo }}</span>
                    </template>
                </ds-text-area-field>

                <ds-filled-button type="submit">
                    {{ sendButton }}
                </ds-filled-button>
            </form>
        </template>
    </ds-modal>
</template>

<script>
import axios from 'axios';

import { SLACK_CHANNELS } from '@/components/util/slack/slack.constants';

const { COMMUNICATIONS_FEEDBACK } = SLACK_CHANNELS;

export default {
    props: {
        source: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            feedback: '',
            showError: false,
            appId: '',
            appEdition: '',
            headerText: '',
            textMsg: '',
            infoText: '',
            warnMsgOne: '',
            sendButton: '',
            warnMsgTwo: '',
        };
    },

    created() {
        if (window.keapI18nMap !== undefined) {
            this.headerText = window.keapI18nMap['funnel.campaign.communications.textmsg.feedbackpopup.header'];
            this.textMsg = window.keapI18nMap['funnel.campaign.communications.textmsg.feedbackpopup.textmsg'];
            this.infoText = window.keapI18nMap['funnel.campaign.communications.textmsg.feedbackpopup.infotext'];
            this.warnMsgOne = window.keapI18nMap['funnel.campaign.communications.textmsg.feedbackpopup.warnmsgone'];
            this.sendButton = window.keapI18nMap['funnel.campaign.communications.textmsg.feedbackpopup.sendbutton'];
            this.warnMsgTwo = window.keapI18nMap['funnel.campaign.communications.textmsg.feedbackpopup.warnmsgtwo'];
        } else {
            this.headerText = 'Share your feedback';
            this.textMsg = 'How can we improve sending text messages from your Keap Marketing Number?';
            this.infoText = 'Please share any details that will help us improve this feature for you.';
            this.warnMsgOne = 'Add your comments';
            this.sendButton = 'Send feedback';
            this.warnMsgTwo = 'Please enter a comment in the text field above to proceed.';
        }
    },

    mounted() {
        this.getAppInfo();
    },

    methods: {
        handleClose() {
            this.showError = false;
            this.$emit('close');
        },

        async getAppInfo() {
            try {
                const { data } = await axios.get('/app/automatedSmsFunnel/getAppInfo');

                this.appEdition = data.appEdition;
                this.appId = data.appId;
            } catch {
                // do nothing
            }
        },

        async submit() {
            if (!this.feedback) {
                this.showError = true;

                return;
            }

            const pretext = [
                `App ID: *${this.appId}*`,
                `Location: *${this.source}*`,
                `Edition: *${this.appEdition}*`,
            ].join('\n');

            this.$slack(COMMUNICATIONS_FEEDBACK, {
                pretext,
                text: this.feedback,
            });

            this.$toast({ message: 'Feedback sent. Thanks!' });
            this.feedback = '';
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
    .sms-broadcast-feedback-modal {
        --modal-padding: #{$spacing-300};
    }

    .feedback-modal-title {
        font-size: $font-size-lg;
    }

    .description1 {
        font-size: $font-size-lg;
        line-height: $line-height-lg;
        font-weight: 300;
    }

    .description2 {
        color: $color-gray-700;
    }

    // This is overriding some default padding
    .feedback-modal-form {
        padding: 0;
    }

    .feedback-help-text {
        color: $color-red;
    }
</style>
